import React from 'react';
import HomeIcon from '@mui/icons-material/Home';
import './styles/navbarmenu.css';
import { useSelector } from 'react-redux';
import {
  Box,
  Divider,
  List,
  ListItem,
  Typography,
  Grid,
  ListItemButton,
  Container,
  Button,
  Tabs,
  Tab,
} from '@mui/material';
import { NavLink, useNavigate } from 'react-router-dom';
import { titleToUrl } from '../../shared/extra';

const navbarStyle = {
  navbarBackground: '#b7010a',
  navbarTextColor: 'white.main',
  homeIconColor: 'white.main',
  homeIconBackgroundColor: 'secondary.main',
  allGiftCardTextColor: 'white.main',
  allGiftCardBackgroundColor: '#00b8ee',
};

const NavbarMenu = () => {
  const [showMenu, setShowMenu] = React.useState(false);
  const [categoryMenuBrands, setCategoryMenuBrands] = React.useState();
  const [currentCategory, setCurrentCategory] = React.useState('');
  const [navbarCss, setNavbarCss] = React.useState(navbarStyle);
  const [tabValue, setTabValue] = React.useState(false);
  const navigate = useNavigate();

  const category = useSelector((state) => state.Category.allData);

  const handleNavbarMenu = (currentProduct, isHovering, products, index) => {
    setShowMenu(isHovering);
    setCurrentCategory(currentProduct);
    setCategoryMenuBrands(products);
    setTabValue(index);
  };

  const handleMouseLeave = () => {
    setShowMenu(false);
    setTabValue(false);
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <Container
      maxWidth="false"
      disableGutters
      onMouseLeave={handleMouseLeave}
      sx={{
        px: { sm: 0 },
        maxHeight: '43px',
        backgroundColor: navbarCss?.navbarBackground,
        borderColor: 'primary.main',
        width: '100%',
      }}
    >
      <Grid sx={{ display: 'flex', alignItems: 'center', position: 'relative' }}>
        {/* Home Icon */}
        <List sx={{ py: 0, position: 'relative', display: 'inline-block' }}>
          <ListItemButton
            onClick={() => navigate('/', { replace: true })}
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'content',
              width: '43px',
              height: '40px',
              backgroundColor: navbarCss?.homeIconBackgroundColor,
              p: 0,
              color: navbarCss?.homeIconColor,
              '&:hover': {
                backgroundColor: navbarCss?.homeIconBackgroundColor,
              },
            }}
          >
            <HomeIcon
              style={{
                width: '43px',
                display: 'block',
                fontSize: '18px',
                textAlign: 'center',
                lineHeight: 1,
                p: '15px 14px',
                textDecoration: 'none',
              }}
            />
          </ListItemButton>
        </List>

        {/* MUI Tabs for Categories */}
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          sx={{
            minHeight: '40px',
            height: '40px',
            flex: 1,
            '& .MuiTabs-flexContainer': {
              justifyContent: 'space-evenly',
            },
            '& .MuiTabs-scrollButtons': {
              color: navbarCss?.navbarTextColor,
              '&.Mui-disabled': {
                opacity: 0.3,
              },
            },
            '& .MuiTabs-indicator': {
              backgroundColor: navbarCss?.homeIconBackgroundColor,
              height: '3px',
            },
          }}
        >
          {category?.map((item, index) => (
            <Tab
              key={`${item?.title}-${index}`}
              label={
                <Typography
                  variant="subtitle1"
                  color={navbarCss?.navbarTextColor}
                  sx={{
                    fontSize: {
                      sm: '11px',
                      lg: '12.5px',
                    },
                    textTransform: 'none',
                    fontWeight: 400,
                  }}
                >
                  {item?.title}
                </Typography>
              }
              onMouseEnter={() => handleNavbarMenu(item?.title, true, item?.products, index)}
              sx={{
                minHeight: '40px',
                height: '40px',
                padding: '6px 12px',
                minWidth: 'auto',
                '&:hover': {
                  backgroundColor: 'secondary.main',
                },
                backgroundColor: tabValue === index ? 'secondary.main' : 'transparent',
              }}
            />
          ))}
        </Tabs>

        <Divider orientation="vertical" flexItem />

        {/* All Gift Cards Button */}
        <List
          sx={{
            py: 0,
            position: 'relative',
            display: 'block',
            width: '100%',
            maxWidth: '130px',
            backgroundColor: 'transparent',
          }}
        >
          <ListItem
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              minWidth: '100%',
              height: '40px',
              backgroundColor: navbarCss?.allGiftCardBackgroundColor,
              px: 0,
            }}
          >
            <NavLink to={'/card-list'}>
              <Button
                variant="text"
                sx={{
                  color: navbarCss?.allGiftCardTextColor,
                  fontSize: '11.5px !important',
                  fontWeight: 400,
                  '&:hover': {
                    textDecoration: 'underline',
                  },
                }}
              >
                All E-Gift Cards
              </Button>
            </NavLink>
          </ListItem>
        </List>
      </Grid>

      <Box
        sx={{
          position: 'relative',
        }}
      >
        {/* All Products show According Menu */}
        <InnerMenu
          showMenu={showMenu}
          currentCategory={currentCategory}
          categoryMenuBrands={categoryMenuBrands}
          handleMouseLeave={handleMouseLeave}
          setShowMenu={setShowMenu}
        />
      </Box>
    </Container>
  );
};

NavbarMenu.propTypes = {};

export default NavbarMenu;

const maxHeight = 370;

function InnerMenu({
  showMenu,
  currentCategory,
  categoryMenuBrands,
  handleMouseLeave,
  setShowMenu,
}) {
  return (
    <Box
      onMouseLeave={handleMouseLeave}
      onMouseEnter={() => setShowMenu(true)}
      sx={{
        position: 'absolute',
        left: {
          sm: 'initial',
          lg: '43px',
        },
        height: `calc(${maxHeight}px)`,
        maxHeight: `calc(${maxHeight}px)`,
        width: '100%',
        maxWidth: {
          sm: '100%',
          lg: 'calc(100% - 192px) !important',
        },
        zIndex: 9,
        background: '#fff',
        display: showMenu ? 'block' : 'none',
        borderRadius: { xs: '0 0 24px 24px' },
        boxShadow: { sm: 4 },
      }}
    >
      <List sx={{ pb: 0 }}>
        <ListItem>
          <Typography
            variant="body2"
            color="dark.main"
            sx={{
              fontSize: { sm: '14.5px', md: '14.5px' },
              fontWeight: 500,
              pb: '.05rem',
            }}
          >
            {currentCategory}
          </Typography>
        </ListItem>
        <Divider />
      </List>
      <List
        sx={{
          pt: 0,
          display: 'grid',
          gridTemplateColumns: 'repeat(3, 1fr)',
          maxHeight: `calc(${maxHeight}px - 51px)`,
          zIndex: 11,
          overflow: 'auto',
          scrollbarWidth: 'thin',
        }}
      >
        {categoryMenuBrands?.map((productItem) => {
          return (
            <NavLink
              key={productItem?.title}
              to={`card-details/${productItem?.id}/${titleToUrl(productItem?.title)}`}
              onClick={() => setShowMenu(false)}
              style={{
                display: 'flex',
                justifyContent: 'center',
                textDecoration: 'none',
              }}
            >
              <ListItem
                sx={{
                  p: { sm: '8px 12px', md: '12px 15px' },
                  m: '0 0 2px 0',
                  '&:hover': {
                    backgroundColor: '#e9ecef',
                    cursor: 'pointer',
                  },
                  '&:active': {
                    color: 'primary.main',
                    cursor: 'pointer',
                  },
                }}
              >
                <Typography
                  variant="body2"
                  sx={{
                    fontSize: { sm: '11.5px', md: '13.5px' },
                    lineHeight: 1,
                    fontWeight: 400,
                    color: 'dark.main',
                  }}
                >
                  {productItem?.title}
                </Typography>
              </ListItem>
            </NavLink>
          );
        })}
      </List>
    </Box>
  );
}
